import { STORE_MODES } from '@/utils/constants';
import {
  StoreList,
  StoreEditor,
} from '@/components';

export default {
  name: 'Store',
  computed: {
    component() {
      switch (this.$route.params.action) {
        case STORE_MODES.CREATE:
        case STORE_MODES.EDIT:
          return StoreEditor;
        case STORE_MODES.LIST:
        default:
          return StoreList;
      }
    },
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  },
};
